import { swSettings } from "app/common/services/swSettings";
import _ from "lodash";
import dayjs from "dayjs";
import { DefaultFetchService, NoCacheHeaders } from "app/services/fetchService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const fetchService = DefaultFetchService.getInstance();

export async function fetchSavedProperties() {
    return await fetchService
        .get(
            "/api/userdata/favorites",
            {
                display: true,
            },
            {
                headers: NoCacheHeaders,
            },
        )
        .then(onSuccess)
        .catch(onFailure);
}

export async function fetchKeywordsCategories() {
    return await fetchService.get("/api/TopApps/StoreOptions").then(onSuccess).catch(onFailure);
}

function onSuccess(data) {
    return {
        success: true,
        payload: data,
    };
}

function onFailure(errMsg) {
    return {
        success: false,
        payload: errMsg,
    };
}

export function transformSavedProperties(data: any, defaultStateOverride: string = null, limitResponseTo: number = 25) {
    if (!data || !data.items || !data.items.length) {
        return [];
    }

    const defaultWebsitePageState = "digitalsuite_website_websiteperformance";
    const defaultAppPageState = "digitalsuite_app_appperformance";
    const websiteState = proNavigator.getState(defaultWebsitePageState);
    const websiteDefaultParams =
        swSettings.components[proNavigator.getConfigId(websiteState)].defaultParams;
    const appState = proNavigator.getState(defaultAppPageState);
    const appDefaultParams = swSettings.components[proNavigator.getConfigId(appState)].defaultParams;
    const stores = { Google: 0, Apple: 1 };
    let result = [];

    data.items.forEach((item) => {
        // sanity
        const itemData = item.data;
        if (!itemData) {
            return;
        }

        const resources = itemData.resources;
        if (!resources) {
            return;
        }

        if (itemData.type === "website" && !_.get(item, "data.comparedItems.length")) {
            result.push({
                Type: itemData.type,
                Name: itemData.mainItem,
                Icon: resources.mainItemFavIcon,
                url: proNavigator.href(defaultStateOverride ?? defaultWebsitePageState, {
                    ...websiteDefaultParams,
                    key: itemData.mainItem,
                    isWWW: "*",
                    webSource: "Total",
                    ...(defaultStateOverride ? proNavigator.getState(defaultStateOverride)?.defaultQueryParams : {}),
                }),
                addedTime: item.addedTime,
                Id: item.id,
            });
        } else if (itemData.type === "app" && !_.get(item, "data.comparedItems.length")) {
            // sanity
            const mainItem = resources.mainItem;
            if (!mainItem) {
                return;
            }
            const tooltip = mainItem.tooltip;
            if (!tooltip) {
                return;
            }

            const appId = `${stores[tooltip.appStore]}_${itemData.mainItem}`;

            result.push({
                Id: item.id,
                Type: itemData.type,
                App: itemData.mainItem,
                Name: itemData.mainItem,
                url: proNavigator.href(defaultStateOverride ?? defaultAppPageState, {
                    ...appDefaultParams,
                    appId,
                }),
                addedTime: item.addedTime,
                Tooltip: {
                    AppStore: tooltip.appStore,
                    Title: tooltip.title,
                    Icon: tooltip.icon,
                    Category: tooltip.category,
                    Author: tooltip.author,
                    Price: tooltip.price,
                },
            });
        }
    });

    result = _.uniqBy(result, "Name").sort((a, b) => (dayjs(a.addedTime).isBefore(dayjs(b.addedTime)) ? 1 : -1));

    // limit number of items to an input cap (default 25)
    if (result.length > limitResponseTo) {
        result = result.slice(0, limitResponseTo);
    }

    return result;
}
